export const GET_DECLINE_REASON_REQ = "GET_DECLINE_REASON_REQ";
export const GET_DECLINE_REASON_FAIL = "GET_DECLINE_REASON_FAIL";
export const GET_DECLINE_REASON_SUCCESS = "GET_DECLINE_REASON_SUCCESS";
export const SAVE_DECLINE_REASON_REQ = "SAVE_DECLINE_REASON_REQ";
export const SAVE_DECLINE_REASON_SUCCESS = "SAVE_DECLINE_REASON_SUCCESS";
export const SAVE_DECLINE_REASON_FAIL = "SAVE_DECLINE_REASON_FAIL";
